import { render, staticRenderFns } from "./excellentCrew.vue?vue&type=template&id=49917c70"
import script from "./excellentCrew.vue?vue&type=script&lang=js"
export * from "./excellentCrew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports